import React, {useEffect, useState} from "react";
import axios from "axios";
import {useNavigate} from "react-router-dom";

const orderStatuses = [
  {id: 1, name: 'Pending', className: 'warning'},
  {id: 2, name: 'Active', className: 'success'},
  {id: 3, name: 'Canceled', className: 'danger'},
  {id: 4, name: 'Delivered', className: 'primary'},
  {id: 5, name: 'Refund', className: 'info refund'},
  {id: 6, name: 'Shipped', className: 'success'},
  {id: 7, name: 'Ready For Shipment', className: 'success'},
]
export default function () {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [errors, setErrors] = useState();

  useEffect(() => {
    axios.get("dashboard/recent-orders").then(res => {
      if (res.data.status === 'success') {
        setData(res.data);
      }
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      }
    });
  }, []);

  return (
    <>
      <h3 className="text-center text-muted mt-15 mb-15 ls-1">Recent Orders</h3>
      <div className="orders-recent rounded bg-main-color px-5">
        <div className="row">
          <div className="col-12 mb-5">
            <div className="order row">
              <table className="table customer-orders align-middle table-row-dashed gy-5 no-footer">
                <thead>
                <tr>
                  <th className="p-0 py-5 pl-3">Order ID</th>
                  <th className="p-0 py-5 pl-3">Status</th>
                  <th className="p-0 py-5 pl-3">Customer</th>
                  <th className="p-0 py-5 pl-3">Amount</th>
                  <th className="p-0 py-5 pl-3">Date</th>
                  <th className="p-0 py-5 pr-3 text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                {
                  data?.recent_orders?.map((order, index) => {
                    return (
                      <tr key={index} className="col-xxl-4 col-xl-6 p-10 mb-lg-0 mb-10">
                        <td
                          className="color-primary cursor-pointer pl-3"
                          title="Open"
                          onClick={() => {
                            navigate(`/orders/${order?.id}`)
                          }}
                        >
                          {order?.id}
                        </td>
                        <td>
                          <span
                            className={`badge ls-1 badge-light-${orderStatuses.find((item) => item.id == order?.status)?.className}`}
                          >
                            {orderStatuses.find((item) => item.id == order?.status)?.name}
                          </span>
                        </td>
                        <td className="fs-6 text-muted">
                          {order?.user?.first_name} {order?.user?.last_name}
                        </td>
                        <td className="text-muted fs-6">
                          {order?.price}
                        </td>
                        <td className="text-muted fs-6">
                          {new Date(order?.created_at).toLocaleDateString('en-GB')}
                        </td>
                        <td className="orders-actions text-right">
                          <i
                            className="fas fa-search-plus mr-3 d-inline fs-3 cursor-pointer"
                            title="Show Details"
                            onClick={() => {
                              navigate("/orders/" + order?.id)
                            }}
                          ></i>
                          <i
                            className="fas fa-edit mr-3 d-inline fs-3 cursor-pointer"
                            title="Edit"
                            onClick={() => {
                              navigate("/orders/" + order?.id + "/edit")
                            }}
                          ></i>
                        </td>
                      </tr>
                    )
                  })
                }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}